module.exports = __webpack_public_path__ + "static/media/in_app_notifications.7ee6753b.png";